<template lang="pug">
  .form-group.form-check
    input.form-check-input(v-model="localData" :disabled="disabled" :class="{'input-error': !isValidInput()}" @change="$emit('update:data', localData, isValidInput())" type="checkbox")
    label.form-check-label {{ booleanLabel }}
</template>

<script>
import Base from '../base'

export default {
  extends: Base,
  created() {
    this.$emit('update:data', false, true)
  },
  accepts(property) {
    return property.type === 'boolean'
  }
}
</script>


// WEBPACK FOOTER //
// src/components/metadataeditor/template/default/Boolean.vue